import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Prismic from 'prismic-javascript'

import Navigation from '../Navigation'
import Footer from '../Footer'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'
const MAX_PAGE_SIZE = 100

export default class LayoutView extends Component {
  state = {
    news: [],
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)

    const createQuery = typeName => [
      Prismic.Predicates.at('document.type', typeName),
      { pageSize: MAX_PAGE_SIZE },
    ]
    await api.query(...createQuery('hir')).then(apiResult => {
      const news = apiResult.results
        .map(newsItem => ({
          ...newsItem.data,
          id: newsItem.id,
        }))
        .filter(i => {
          return i.fooldal === 'igen'
        })
      this.setState({
        news,
      })
    })
  }

  render() {
    const { noHero, children } = this.props
    return (
      <div className="page">
        <Navigation />
        <header>
          {!noHero && (
            <div className="hero">
              <Grid>
                <Row>
                  <Col xs={12} md={6} className="">
                    <Row>
                      <Col xs={12}>
                        <div className="h1">Legutóbbi híreink</div>
                      </Col>
                    </Row>
                    {this.state.news.map(newsItem => (
                      <Row key={newsItem.id}>
                        <Col xs={12}>
                          <Link to={`/hirek/${newsItem.id}`}>
                            <div className="newsItem">
                              <div className="title">{newsItem.cim}</div>
                              <div className="details">
                                {newsItem.datum} - {newsItem.szerzo}
                              </div>
                            </div>
                          </Link>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                  <Col xs={12} md={6} className="openingHours">
                    <Row>
                      <Col xs={12}>
                        <div className="h1">Nyitvatartás</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <div className="newsItem">
                          <div className="title">Hétfö - Péntek</div>
                          <div className="time">9:00 - 19:00</div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <div className="newsItem">
                          <div className="title">Szombat</div>
                          <div className="time">9:00 - 13:00</div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <div className="newsItem">
                          <div className="title">Vasárnap</div>
                          <div className="time">Zárva</div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Grid>
            </div>
          )}
        </header>
        <main>{children}</main>
        <footer>
          <a className="anchor" id="contact" />
          <Footer />
        </footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Page/PageView.js